<template>
  <div class="home-foot">
    <div class="foot-top">
      <div class="title">
        距离不再遥<span class="title-big">远</span>
        <span
          :style="{
            'padding-left': isMobile ? '38px' : '55px',
            'margin-right': isMobile ? '-15px' : '-23px',
          }"
        >
          人才<span class="title-big">近</span>在眼前</span
        >
      </div>
      <div class="call">
        <i class="iconfont icondianhua1"></i>
        <span v-html="config.Landline"></span>
      </div>
      <div class="bottom-btns">
        <a @click="goTest" class="btn-blue-hover">试用</a
        ><a @click="chatShow">咨询顾问</a>
      </div>
    </div>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {},
      isMobile: false,
      isPcDialogShow: false,
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    if (this.loadConfig.concat) {
      this.config = this.loadConfig.concat
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.concat) {
        this.config = newVal.concat
      }
    },
  },
  methods: {
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
  },
}
</script>
<style lang="scss" scoped>
.home-foot {
  padding: 0px;
  background: #fff;
  height: 280px;
  .foot-top {
    background: url('~@/static/images/foot-top.png');
    background-size: cover;
    height: 280px;
    padding: 40px 0px 0px;
    text-align: center;
    width: 100%;
    .title {
      display: block;
      font-size: 30px;
      font-weight: 300;
      color: #fff;
      .title-big {
        font-size: 44px;
      }
    }
    .subtitle {
    }
    .call {
      color: #29bdb9;
      padding: 20px 0 10px 0;
      font-size: 30px;
      i {
        font-size: 30px;
      }
    }
    .bottom-btns {
      padding: 20px 0px 0px;
      a {
        font-size: 14px;
        padding: 6px 30px;
        cursor: pointer;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 2px;
        margin-right: 20px;
        &:hover {
          border: 2px solid #29bdb9;
          background: #29bdb9;
          color: #fff;
        }
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .home-foot {
    height: 220px;

    .foot-top {
      height: 220px;
      .title {
        font-size: 20px;
        .title-big {
          font-size: 30px;
        }
      }
      .call {
        font-size: 20px;
        i {
          font-size: 20px;
        }
      }
      .bottom-btns {
        padding: 10px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/footer.vue